import { salesChannelResourceNameGenerator } from 'src/tools/getUserInfo';
import {
  EnumCategory,
  EnumSubCategory,
  EnumOperation,
} from 'src/types/common/resources';
import { union } from 'lodash';

const contentListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.view_content_version_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.view_content_version_details,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.create_duplicate_edit_draft_content_version,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.create_duplicate_edit_live_content_version,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.publish_unpublish_version,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.delete_version,
      uuid,
    }),
  ];
};

const contentDetailPage = (params) => {
  const { saleChannelUuid: uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.create_duplicate_edit_draft_content_version,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.create_duplicate_edit_live_content_version,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.view_content_version_details,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelContent,
      subCategory: EnumSubCategory.ChannelContent,
      operation: EnumOperation.delete_version,
      uuid,
    }),
  ];
};

const productListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_all_products_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_product_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.add_edit_product,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.delete_product,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_content_version_listing_page,
      uuid,
    }),
  ];
};

const productDetailPage = (params) => {
  const { saleChannelUuid: uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_all_products_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_product_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.add_edit_product,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.delete_product,
      uuid,
    }),
  ];
};

const promotionTagListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.add_edit_promotion_tag,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.delete_promotion_tag,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_all_promotion_tags_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_promotion_tag_details_page,
      uuid,
    }),
  ];
};

const promotionTagDetailPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.add_edit_promotion_tag,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.delete_promotion_tag,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_all_promotion_tags_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProduct,
      subCategory: EnumSubCategory.ChannelProduct,
      operation: EnumOperation.view_promotion_tag_details_page,
      uuid,
    }),
  ];
};

const categoryPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelCategory,
      subCategory: EnumSubCategory.ChannelProductCategory,
      operation: EnumOperation.view_category_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelCategory,
      subCategory: EnumSubCategory.ChannelProductCategory,
      operation: EnumOperation.add_edit_category,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelCategory,
      subCategory: EnumSubCategory.ChannelProductCategory,
      operation: EnumOperation.delete_category,
      uuid,
    }),
  ];
};

const maintenancePage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelMaintenancePage,
      subCategory: EnumSubCategory.ChannelMaintenancePage,
      operation: EnumOperation.view_maintenance_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelMaintenancePage,
      subCategory: EnumSubCategory.ChannelMaintenancePage,
      operation: EnumOperation.view_maintenance_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelMaintenancePage,
      subCategory: EnumSubCategory.ChannelMaintenancePage,
      operation: EnumOperation.view_maintenance_page,
      uuid,
    }),
  ];
};

const collectionPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProductCollection,
      subCategory: EnumSubCategory.ChannelProductCollection,
      operation: EnumOperation.view_all_collections_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProductCollection,
      subCategory: EnumSubCategory.ChannelProductCollection,
      operation: EnumOperation.view_collection_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProductCollection,
      subCategory: EnumSubCategory.ChannelProductCollection,
      operation: EnumOperation.add_edit_product_collection,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelProductCollection,
      subCategory: EnumSubCategory.ChannelProductCollection,
      operation: EnumOperation.delete_product_collection,
      uuid,
    }),
  ];
};

const legalListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_all_legal_page_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_legal_page_details,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.add_edit_legal_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.archive_legal_page,
      uuid,
    }),
  ];
};

const legalDetailPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_legal_page_details,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.add_edit_legal_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.archive_legal_page,
      uuid,
    }),
  ];
};

const tcListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_all_T_C_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_T_C_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.add_edit_T_C,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.archive_T_C,
      uuid,
    }),
  ];
};

const tcDetailPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.view_T_C_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.add_edit_T_C,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelLegal,
      subCategory: EnumSubCategory.ChannelLegal,
      operation: EnumOperation.archive_T_C,
      uuid,
    }),
  ];
};

const discountListPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.view_all_discounts_listing_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.view_discount_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.add_edit_discount,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.archive_discount,
      uuid,
    }),
  ];
};

const discountDetailPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.view_discount_details_page,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.add_edit_discount,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelDiscount,
      subCategory: EnumSubCategory.ChannelDiscount,
      operation: EnumOperation.archive_discount,
      uuid,
    }),
  ];
};

const invoicePage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelInvoice,
      operation: EnumOperation.edit_invoice_settings,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelInvoice,
      operation: EnumOperation.view_invoice_settings,
      uuid,
    }),
  ];
};

const digitalMarketPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelDigitalMarketing,
      operation: EnumOperation.edit_digital_marketing_settings,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelDigitalMarketing,
      operation: EnumOperation.view_digital_marketing_settings,
      uuid,
    }),
  ];
};

const currencyPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCurrency,
      operation: EnumOperation.edit_currency_settings,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCurrency,
      operation: EnumOperation.view_currency_setting,
      uuid,
    }),
  ];
};

const logisticsPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLogistics,
      operation: EnumOperation.edit_logistics_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLogistics,
      operation: EnumOperation.view_logistic_setting,
      uuid,
    }),
  ];
};

const localisationPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLocalisation,
      operation: EnumOperation.edit_localisation_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLocalisation,
      operation: EnumOperation.view_localisation_setting,
      uuid,
    }),
  ];
};

const inventoryPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelInventory,
      operation: EnumOperation.edit_inventory_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelInventory,
      operation: EnumOperation.view_inventory_setting,
      uuid,
    }),
  ];
};

const languagePage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLanguage,
      operation: EnumOperation.edit_language_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLanguage,
      operation: EnumOperation.view_language_setting,
      uuid,
    }),
  ];
};

const orderPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelOrder,
      operation: EnumOperation.edit_order_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelOrder,
      operation: EnumOperation.view_order_setting,
      uuid,
    }),
  ];
};

const cookiesPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCookies,
      operation: EnumOperation.edit_cookies_settings,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCookies,
      operation: EnumOperation.view_coolies_setting,
      uuid,
    }),
  ];
};

const paymentPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelPayment,
      operation: EnumOperation.edit_payment_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelPayment,
      operation: EnumOperation.view_payment_settings,
      uuid,
    }),
  ];
};

const checkoutPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCheckout,
      operation: EnumOperation.edit_checkout_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCheckout,
      operation: EnumOperation.view_checkout_settings,
      uuid,
    }),
  ];
};

const registrationPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelRegistration,
      operation: EnumOperation.edit_registration_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelRegistration,
      operation: EnumOperation.view_registration_settings,
      uuid,
    }),
  ];
};

const logoPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLogoManagement,
      operation: EnumOperation.edit_logo_management,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelLogoManagement,
      operation: EnumOperation.view_logo_management_settings,
      uuid,
    }),
  ];
};

const domainPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelDomainAndStatus,
      operation: EnumOperation.edit_domain_and_status,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelDomainAndStatus,
      operation: EnumOperation.view_domain_and_status,
      uuid,
    }),
  ];
};

const miniProgramPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelMiniProgramSetting,
      operation: EnumOperation.edit_Mini_program_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelMiniProgramSetting,
      operation: EnumOperation.view_Mini_program_settings,
      uuid,
    }),
  ];
};

const taxPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelTax,
      operation: EnumOperation.edit_tax_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelTax,
      operation: EnumOperation.view_tax_settings,
      uuid,
    }),
  ];
};

const communicationPage = (params) => {
  const { uuid } = params;
  return [
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCommunication,
      operation: EnumOperation.edit_communication_setting,
      uuid,
    }),
    salesChannelResourceNameGenerator({
      category: EnumCategory.SalesChannelSettings,
      subCategory: EnumSubCategory.ChannelCommunication,
      operation: EnumOperation.view_communication_settings,
      uuid,
    }),
  ];
};

const settingPage = (params) => {
  return union(
    communicationPage(params),
    taxPage(params),
    miniProgramPage(params),
    domainPage(params),
    logoPage(params),
    registrationPage(params),
    checkoutPage(params),
    paymentPage(params),
    cookiesPage(params),
    orderPage(params),
    languagePage(params),
    inventoryPage(params),
    localisationPage(params),
    logisticsPage(params),
    currencyPage(params),
    digitalMarketPage(params),
    invoicePage(params),
  );
};

export {
  communicationPage,
  taxPage,
  miniProgramPage,
  domainPage,
  logoPage,
  registrationPage,
  checkoutPage,
  paymentPage,
  cookiesPage,
  orderPage,
  languagePage,
  inventoryPage,
  localisationPage,
  logisticsPage,
  currencyPage,
  digitalMarketPage,
  invoicePage,
  discountDetailPage,
  discountListPage,
  tcDetailPage,
  tcListPage,
  legalDetailPage,
  legalListPage,
  collectionPage,
  categoryPage,
  maintenancePage,
  promotionTagDetailPage,
  promotionTagListPage,
  productDetailPage,
  productListPage,
  contentDetailPage,
  contentListPage,
  settingPage,
};
